import * as React from 'react';
import {
    Box,
    Button,
    Container,
    Grid2,
    MenuItem,
    Stack,
    TextField,
    Toolbar,
    Typography
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import ModernNavbar from '../setup/ModernNavbar';
import Footer from '../setup/Footer';
import Loading from '../../BuiltInComponent/Loading';
import TableDataWithPagination from '../../BuiltInComponent/TableWithPagination';
import { getYear, getMonth } from '../../features/setup/useableSlice';
import { getUnits } from '../../features/AdminManagement/unitsSlice';
import { getEligibleAdvances, getSkipList, addSkip, deleteSkip } from '../../features/AdminManagement/advanceSkipSlice';

export default function AdvanceDeductionSkip() {
    const dispatch = useDispatch();

    const { years, months } = useSelector((state) => state.ru);
    const { units } = useSelector((state) => state.units);
    const { eligible, skipList, isLoading } = useSelector((state) => state.advSkip);

    const [filter, setFilter] = React.useState({
        year: '',
        month: '',
        unitID: ''
    });

    const eligibleColumns = [
        { fieldName: 'advID', cName: 'ID', textAlign: 'left', dType: 'string', status: 'en' },
        { fieldName: 'advID', cName: 'Advance ID', textAlign: 'left', dType: 'string', status: 'en' },
        { fieldName: 'empName', cName: 'Employee', textAlign: 'left', dType: 'string', status: 'en' },
        { fieldName: 'amount', cName: 'Amount', textAlign: 'right', dType: 'number', status: 'en' },
        { fieldName: 'installments', cName: 'Installments', textAlign: 'right', dType: 'number', status: 'en' },
        { fieldName: 'recovered_amount', cName: 'Recovered', textAlign: 'right', dType: 'number', status: 'en' },
        { fieldName: 'balance_amount', cName: 'Balance', textAlign: 'right', dType: 'number', status: 'en' },
        { fieldName: 'advDate', cName: 'Advance Date', textAlign: 'left', dType: 'date', status: 'en' },
        { fieldName: 'skip', cName: 'Skip', textAlign: 'center', width: 50, status: 'en' },
        { fieldName: 'delete', cName: 'Delete', textAlign: 'center', width: 50, status: 'dis' },
        { fieldName: 'delete', cName: 'Delete', textAlign: 'center', width: 50, status: 'dis' }
    ];

    const skipColumns = [
        { fieldName: 'skipID', cName: 'ID', textAlign: 'left', dType: 'string', status: 'en' },
        { fieldName: 'advID', cName: 'Advance ID', textAlign: 'left', dType: 'string', status: 'en' },
        { fieldName: 'empName', cName: 'Employee', textAlign: 'left', dType: 'string', status: 'en' },
        { fieldName: 'amount', cName: 'Amount', textAlign: 'right', dType: 'number', status: 'en' },
        { fieldName: 'installments', cName: 'Installments', textAlign: 'right', dType: 'number', status: 'en' },
        { fieldName: 'monthTag', cName: 'Month', textAlign: 'left', dType: 'string', status: 'en' },
        { fieldName: 'created_at', cName: 'Created', textAlign: 'left', dType: 'date', status: 'en' },
        { fieldName: 'edit', cName: 'Edit', textAlign: 'center', width: 50, status: 'dis' },
        { fieldName: 'delete', cName: 'Remove', textAlign: 'center', width: 50, status: 'en' },
        { fieldName: 'delete', cName: 'Delete', textAlign: 'center', width: 50, status: 'dis' }
    ];

    React.useEffect(() => {
        dispatch(getYear());
        dispatch(getUnits());
    }, [dispatch]);

    const handleYearChange = (e) => {
        const year = e.target.value;
        setFilter((prev) => ({ ...prev, year, month: '' }));
        if (year) {
            dispatch(getMonth({ year }));
        }
    };

    const handleMonthChange = (e) => {
        setFilter((prev) => ({ ...prev, month: e.target.value }));
    };

    const handleUnitChange = (e) => {
        setFilter((prev) => ({ ...prev, unitID: e.target.value }));
    };

    const loadData = () => {
        if (!filter.year || !filter.month) {
            alert('Please select year and month.');
            return;
        }
        dispatch(getEligibleAdvances({ year: filter.year, month: filter.month, unitID: filter.unitID || undefined }));
        dispatch(getSkipList({ year: filter.year, month: filter.month }));
    };

    const onSkipClick = async (advID) => {
        if (!filter.year || !filter.month) return;
        await dispatch(addSkip({ advID, year: filter.year, month: filter.month }));
        loadData();
    };

    const onRemoveClick = async (skipID) => {
        await dispatch(deleteSkip(skipID));
        loadData();
    };

    return (
        <>
            <ModernNavbar />
            <Toolbar />
            <Container maxWidth="lg">
                <Box sx={{ backgroundColor: '#1E90FF', mb: 3, borderRadius: 2, color: 'white', textShadow: 'black 4px 4px 10px' }}>
                    <Typography sx={{ textAlign: 'center', fontSize: 28, fontWeight: 'bolder' }}>Advance Deduction Skip</Typography>
                </Box>

                <Grid2 container spacing={2} sx={{ mb: 2 }}>
                    <Grid2 size={3}>
                        <TextField
                            select
                            label="Year"
                            value={filter.year}
                            onChange={handleYearChange}
                            fullWidth
                            size="small"
                        >
                            {years.map((y) => (
                                <MenuItem key={y.yearID} value={y.yearID}>{y.year}</MenuItem>
                            ))}
                        </TextField>
                    </Grid2>
                    <Grid2 size={3}>
                        <TextField
                            select
                            label="Month"
                            value={filter.month}
                            onChange={handleMonthChange}
                            fullWidth
                            size="small"
                        >
                            {months.map((m) => (
                                <MenuItem key={m.month_no} value={m.month_no}>{m.month_name}</MenuItem>
                            ))}
                        </TextField>
                    </Grid2>
                    <Grid2 size={3}>
                        <TextField
                            select
                            label="Unit (optional)"
                            value={filter.unitID}
                            onChange={handleUnitChange}
                            fullWidth
                            size="small"
                        >
                            <MenuItem value="">All Units</MenuItem>
                            {units.map((u) => (
                                <MenuItem key={u.unitID} value={u.unitID}>{u.unitDescription}</MenuItem>
                            ))}
                        </TextField>
                    </Grid2>
                    <Grid2 size={3}>
                        <Stack direction="row" spacing={2} alignItems="center" sx={{ height: '100%' }}>
                            <Button variant="contained" onClick={loadData} fullWidth>Load</Button>
                        </Stack>
                    </Grid2>
                </Grid2>

                {isLoading ? <Loading /> : (
                    <>
                        <Typography sx={{ mb: 1, fontWeight: 700 }}>Eligible Advances (Approved, Balance > 0, Installments > 1)</Typography>
                        <TableDataWithPagination
                            tableColumns={eligibleColumns}
                            tableData={eligible}
                            onEditClick={onSkipClick}
                            onDeleteClick={() => { }}
                        />

                        <Box sx={{ mt: 4 }}>
                            <Typography sx={{ mb: 1, fontWeight: 700 }}>Skipped for Selected Month</Typography>
                            <TableDataWithPagination
                                tableColumns={skipColumns}
                                tableData={skipList}
                                onEditClick={() => { }}
                                onDeleteClick={onRemoveClick}
                            />
                        </Box>
                    </>
                )}
            </Container>
            <Footer />
        </>
    );
}
